import { DatePicker, Space } from 'antd';

interface IDateTime {
  getDate: Function;
}
const { RangePicker } = DatePicker;
function DataPicker({ getDate }: IDateTime) {
  const dateFormat = 'YYYY-MM-DD';
  return (
    <Space direction="vertical" size={12} className="dataPicker stylePlace">
      <RangePicker
        placeholder={['YYYY.MM.DD', 'YYYY.MM.DD']}
        onChange={(date: any, dateString: [string, string]) => {
          getDate(dateString);
        }}
        // defaultValue={[
        //   moment(moment(), dateFormat),
        //   moment(moment(), dateFormat),
        // ]}
        format={dateFormat}
      />
    </Space>
  );
}

export default DataPicker;
